<app-login-shell
  [mode]="'cliente'"
  [loading]="loading"
  [error]="loginError"
  [success]="successMessage"
  [successTitle]="(('sendLinkAccess' | translate) + ' ' + username)"
  [successSubtitle]="'compilationLinkMessage' | translate"
  [showRecover]="false"
  [codeLoading]="codeLoading"
  [codeError]="codeError"
  (submit)="onShellSubmit($event)"
  (codeSubmit)="onShellCode($event)">
</app-login-shell>
